// extracted by mini-css-extract-plugin
module.exports = {"basket":"styles_basket__ChRZU","container":"styles_container__33oL-","emptyBasket":"styles_emptyBasket__11cYN"};